<template>
    <Main>
        <box-loading v-if="isLoading"> </box-loading>
        <el-row :gutter="30" v-if="dataRecord && !isLoading && listFields">
            <template v-for="item in listFields">
                <el-col v-if="![TYPE_TEXTS, TYPE_SUB_TABLE].includes(item.type)" :span="12" :xs="24" :key="item.code">
                    <InputField v-if="item.type !== TYPE_RECORD_NUMBER" :span-input="18" :span-label="6" :label-text="item.label" classes="mb-4" :is-required="item.required">
                        <input-kintone-setting
                            :type-input="item.type"
                            v-model="dataRecord[item.code]"
                            :options="item.options"
                            :lookup="item.lookup"
                            @onValidate="onValidate(item.code)"
                            :data-local="dataMaster"
                            :formatCalc="item.format"
                            :protocol-link="item.protocol"
                            :unit="item.unit"
                        ></input-kintone-setting>
                        <template #error v-if="errorInfo[item.code]">
                            {{ errorInfo[item.code] }}
                        </template>
                    </InputField>
                </el-col>
                <el-col v-else :span="24" :key="item.code + 'two'">
                    <InputField type="vertical" :span-input="21" :span-label="3" classes="mb-3" :label-text="item.label">
                        <textarea class="form-control" :rows="3" v-if="item.type === TYPE_TEXTS" v-model="dataRecord[item.code]"> </textarea>
                        <div v-if="item.type === TYPE_SUB_TABLE" class="table-sm table-kb">
                            <table class="table table-hover table-common" v-if="item.fields">
                                <thead>
                                    <tr class="row-preview row-preview__header">
                                        <th scope="col" v-for="field in item.fields" :key="field.code">
                                            {{ field.label }}
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(rowSub, indexR) in dataRecord[item.code]" :key="indexR" class="row-preview row-preview--top row-preview__content">
                                        <td v-for="(fieldSub, indexSub) in rowSub.value" :key="indexSub">
                                            <input-kintone-setting
                                                :type-input="fieldSub.type"
                                                v-model="fieldSub.value"
                                                :options="fieldSub.options"
                                                :lookup="fieldSub.lookup"
                                                :data-local="dataMaster"
                                                :protocol-link="item.protocol"
                                                :formatCalc="fieldSub.format"
                                                :unit="item.unit"
                                            >
                                            </input-kintone-setting>
                                        </td>
                                        <td class="col-sub-table">
                                            <i @click="onDeleteRowSubTable(item.code, indexR)" :class="{ disabled: dataRecord[item.code].length < 2 }" class="el-icon-remove icon-remove mx-2"></i>
                                            <i @click="onAddRowSubTable(item, indexR, item.code)" class="el-icon-circle-plus icon-plus mx-2"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </InputField>
                    <template #error v-if="item.error">{{ item.error }}</template>
                </el-col>
            </template>
        </el-row>
        <template #bottomAction>
            <div class="text-right">
                <Button type="warning" @click="handleCancel">
                    {{ $t('button.cancel') }}
                </Button>
                <Button type="primary" classes="ml-3" @click="handleSubmitData">
                    {{ $t('button.register') }}
                </Button>
            </div>
        </template>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import Button from '@/components/partials/Button';
import BoxLoading from '@/components/partials/BoxLoading';
import InputField from '@/components/partials/InputField';
import isUrl from 'is-url';

import {
    TYPE_CHECK_BOX,
    TYPE_DROPDOWN,
    TYPE_RADIO_BUTTON,
    TYPE_TEXTS,
    TYPE_SUB_TABLE,
    TYPE_DATE_TIME,
    TYPE_DATE,
    TYPE_RECORD_NUMBER,
    TYPE_MULTI_SELECT,
    TYPE_CREATED_TIME,
    TYPE_CREATOR,
    TYPE_UPDATE_TIME,
    TYPE_MODIFIER,
    TYPE_LINK,
    TYPE_CALC,
    TYPE_FILE,
    TYPE_ORGANIZATION_SELECT
} from '@/config/constants';
import { formatDateTime, formatDateTimeZoneWithHour, validEmail } from '@/utils';
import { mapState } from 'vuex';
import InputKintoneSetting from '@/components/partials/InputKintonSetting.vue';
export default {
    components: {
        InputKintoneSetting,
        BoxLoading,
        Main,
        Button,
        InputField
    },
    data() {
        return {
            TYPE_CREATED_TIME,
            TYPE_CREATOR,
            TYPE_UPDATE_TIME,
            TYPE_MODIFIER,
            isLoading: false,
            dataRecord: {},
            listFields: [],
            TYPE_TEXTS,
            TYPE_SUB_TABLE,
            TYPE_RECORD_NUMBER,
            fieldSubRows: {},
            errorInfo: {},
            dataMaster: {
                users: [],
                groups: [],
                departments: []
            }
        };
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        isAccountAdmin() {
            if (localStorage.getItem('KB_DEV_CUSTOMER') || this.userInfo) {
                let user = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) || this.userInfo;
                if (user) {
                    let roleUser = parseInt(user.type);
                    return roleUser === 2;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    created() {
        let idShare = this.$route.query.idShare || '';
        if (idShare) {
            this.handleGetListFields(idShare);
            this.handleGetListGroupUser(idShare);
        }
    },
    methods: {
        handleGetListGroupUser(idShare) {
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { data } = response.data.data;
                    this.dataMaster.users = [].concat(
                        data.user.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster.departments = [].concat(
                        data.department.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster.groups = [].concat(
                        data.group.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster = Object.assign({}, this.dataMaster);
                }
            };
            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback,
                shareId: idShare
            };

            this.$store.dispatch('share/getAllGroupUser', payload);
        },
        handleGetListFields(idShare) {
            this.isLoading = true;
            let successCallback = (response) => {
                let { data } = response.data.data;
                this.isLoading = false;
                if (data && data.fields) {
                    this.listFields = [];
                    Object.keys(data.fields).map((keyField) => {
                        let field = data.fields[keyField];
                        this.errorInfo[keyField] = '';
                        if ([TYPE_DROPDOWN, TYPE_CHECK_BOX, TYPE_RADIO_BUTTON, TYPE_MULTI_SELECT].includes(field.type)) {
                            this.listFields.push(field);
                            if (field.type === TYPE_DROPDOWN || field.type === TYPE_MULTI_SELECT) {
                                field.options = Object.keys(field.options).sort();
                            } else {
                                let arrayOptions = [];
                                Object.keys(field.options).map((key) => {
                                    arrayOptions.push({
                                        label: key,
                                        value: key
                                    });
                                });
                                field.options = arrayOptions.sort(function (a, b) {
                                    return a.label.localeCompare(b.label);
                                });
                            }
                            if ([TYPE_CHECK_BOX, TYPE_MULTI_SELECT].includes(field.type)) {
                                this.dataRecord[keyField] = field.defaultValue && field.defaultValue.length > 0 ? field.defaultValue : [];
                            } else {
                                this.dataRecord[keyField] = field.defaultValue || '';
                            }
                        } else if (field.type === TYPE_ORGANIZATION_SELECT) {
                            this.listFields.push(field);
                            this.dataRecord[keyField] = [];
                        } else if (field.type === TYPE_SUB_TABLE) {
                            let fieldItems = field.fields;
                            field.fields = [];
                            this.dataRecord[keyField] = [
                                {
                                    id: '',
                                    value: {}
                                }
                            ];
                            let objValue = {};
                            Object.keys(fieldItems).map((keyFieldItem, indexF) => {
                                field.fields.push(fieldItems[keyFieldItem]);
                                objValue[keyFieldItem] = {
                                    type: fieldItems[keyFieldItem].type,
                                    value: fieldItems[keyFieldItem].defaultValue || ''
                                };
                                if (fieldItems[keyFieldItem] && fieldItems[keyFieldItem].options) {
                                    let optionList = [];
                                    Object.keys(fieldItems[keyFieldItem].options).map((optionKey) => {
                                        optionList.push({
                                            value: optionKey,
                                            label: optionKey
                                        });
                                    });
                                    if ([TYPE_CHECK_BOX, TYPE_RADIO_BUTTON].includes(fieldItems[keyFieldItem].type)) {
                                        objValue[keyFieldItem].options = optionList.sort(function (a, b) {
                                            return a.label.localeCompare(b.label);
                                        });
                                    } else if (fieldItems[keyFieldItem].type === TYPE_DROPDOWN || fieldItems[keyFieldItem].type === TYPE_MULTI_SELECT) {
                                        objValue[keyFieldItem].options = Object.keys(fieldItems[keyFieldItem].options).sort();
                                    } else if (fieldItems[keyFieldItem].type === TYPE_CALC) {
                                        objValue[keyFieldItem].format = fieldItems[keyFieldItem].format;
                                    }
                                }
                                if (fieldItems[keyFieldItem] && fieldItems[keyFieldItem].lookup) {
                                    objValue[keyFieldItem].lookup = fieldItems[keyFieldItem].lookup;
                                }
                            });
                            this.dataRecord[keyField][0].value = objValue;
                            this.fieldSubRows[keyField] = objValue;
                            this.listFields.push(field);
                        } else {
                            this.dataRecord[keyField] = field.defaultValue || '';
                            this.listFields.push(field);
                        }
                    });
                    let listFieldNotCreate = [TYPE_UPDATE_TIME, TYPE_CREATOR, TYPE_MODIFIER, TYPE_CREATED_TIME];
                    this.listFields = this.listFields.filter((elm) => !listFieldNotCreate.includes(elm.type));
                }
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                appId: idShare
            };
            this.$store.dispatch('share/getListFieldRecords', payload);
        },
        handleCancel() {
            let idShare = this.$route.query.idShare || '';
            let idDataLink = this.$route.query.idDataLink || '';
            this.$router.push({
                name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataViewCreate' ? 'dataLinkMultiDataView' : 'dataView') : 'dataViewChildren',
                query: {
                    id: idShare,
                    idDataLink: idDataLink,
                    link_name: this.$route.query.link_name ?? ''
                }
            });
        },
        onDeleteRowSubTable(key, indexRow) {
            if (this.dataRecord[key] && this.dataRecord[key].length > 1) {
                this.dataRecord[key].splice(indexRow, 1);
            }
        },
        onAddRowSubTable(itemField, rowIndex, itemCode) {
            let obj = {
                id: '',
                value: this.fieldSubRows[itemCode]
            };
            const itemFieldGet = Object.assign({}, itemField);
            if (itemFieldGet && itemFieldGet.fields.length > 0) {
                itemFieldGet.fields.map((elm) => {
                    obj.value[elm.code] = {
                        type: elm.type,
                        value: elm.defaultValue ? elm.defaultValue : ''
                    };
                    if (elm.lookup) {
                        obj.value[elm.code].lookup = elm.lookup;
                    }
                    if (elm.options) {
                        if (elm.type === TYPE_DROPDOWN || elm.type === TYPE_MULTI_SELECT) {
                            obj.value[elm.code].options = Object.keys(elm.options);
                        } else {
                            obj.value[elm.code].options = [];
                            Object.keys(elm.options).map((key) => {
                                let objOption = {
                                    value: key,
                                    label: key
                                };
                                obj.value[elm.code].options.push(objOption);
                            });
                        }
                    }
                    if ([TYPE_ORGANIZATION_SELECT, TYPE_CHECK_BOX, TYPE_MULTI_SELECT].includes(elm.type)) {
                        obj.value[elm.code].value = [];
                    }
                });
            }
            this.dataRecord[itemFieldGet.code].splice(rowIndex + 1, 0, obj);
            this.dataRecord[itemFieldGet.code] = [].concat(this.dataRecord[itemFieldGet.code]);
            this.dataRecord = Object.assign({}, this.dataRecord);
        },
        handleSubmitData() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    if (response.status === 200) {
                        let responseData = response.data.data.data;
                        let statusError = responseData.status || false;
                        if (statusError) {
                            this.$store.commit('noticeSystem/SET_MESSAGE', {
                                isShowMessage: true,
                                type: 'success',
                                message: this.$t('recordForm.msgCreateSuccessfully')
                            });
                            this.$router.push({
                                name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataViewCreate' ? 'dataLinkMultiDataView' : 'dataView') : 'dataViewChildren',
                                query: {
                                    id: this.$route.query.idShare,
                                    idDataLink: this.$route.query.idDataLink ?? '',
                                    link_name: this.$route.query.link_name ?? ''
                                }
                            });
                        } else {
                            let messageError = responseData.error ? `[${responseData.error.code}] ${responseData.error.message}` : '';
                            this.$store.commit('noticeSystem/SET_MESSAGE', {
                                isShowMessage: true,
                                type: 'error',
                                message: messageError
                            });
                        }
                    }
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let { dataRecord } = this;
                let dataPayload = [];
                let objectRecord = {};
                Object.keys(dataRecord).map((key) => {
                    let typeField = '';
                    let indexField = this.listFields.findIndex((elm) => elm.code === key);
                    if (indexField >= 0 || key === '$id') {
                        if (key === '$id') {
                            objectRecord[key] = {
                                type: '__ID__',
                                value: dataRecord[key]
                            };
                        } else {
                            typeField = this.listFields[indexField].type;
                            if (typeField !== TYPE_SUB_TABLE) {
                                if (typeField === TYPE_DATE_TIME) {
                                    objectRecord[key] = {
                                        type: typeField,
                                        value: dataRecord[key] ? formatDateTimeZoneWithHour('', dataRecord[key]) : ''
                                    };
                                } else if (typeField === TYPE_DATE) {
                                    objectRecord[key] = {
                                        type: typeField,
                                        value: dataRecord[key] ? formatDateTime(dataRecord[key], 'YYYY-MM-DD') : ''
                                    };
                                } else if ([TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(typeField)) {
                                    objectRecord[key] = {
                                        type: typeField,
                                        value: dataRecord[key] ? dataRecord[key].join(';') : ''
                                    };
                                } else if (typeField === TYPE_CALC || typeField === TYPE_FILE) {
                                    objectRecord[key] = {
                                        type: typeField,
                                        value: ''
                                    };
                                } else {
                                    objectRecord[key] = {
                                        type: typeField,
                                        value: dataRecord[key]
                                    };
                                }
                            } else {
                                if (dataRecord[key]) {
                                    let dataTable = [];

                                    dataRecord[key].map((elm) => {
                                        let obj = {
                                            id: elm.id,
                                            value: {}
                                        };
                                        let valueElm = elm.value;
                                        Object.keys(valueElm).map((keyField) => {
                                            obj.value[keyField] = {
                                                type: valueElm[keyField].type,
                                                value: valueElm[keyField].value
                                            };
                                            if ([TYPE_CHECK_BOX, TYPE_DROPDOWN, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(valueElm[keyField].type)) {
                                                if (obj.value[keyField].value && Array.isArray(obj.value[keyField].value)) {
                                                    obj.value[keyField].value = obj.value[keyField].value ? obj.value[keyField].value.join(';') : '';
                                                }
                                            } else if (valueElm[keyField].type === TYPE_DATE_TIME) {
                                                obj.value[keyField].value = obj.value[keyField].value ? formatDateTimeZoneWithHour('', obj.value[keyField].value) : '';
                                            } else if (valueElm[keyField].type === TYPE_DATE) {
                                                obj.value[keyField].value = obj.value[keyField].value ? formatDateTime(obj.value[keyField].value, 'YYYY-MM-DD') : '';
                                            } else if (valueElm[keyField].type === TYPE_CALC || valueElm[keyField].type === TYPE_FILE) {
                                                obj.value[keyField].value = '';
                                            }
                                        });
                                        dataTable.push(obj);
                                    });

                                    objectRecord[key] = {
                                        type: typeField,
                                        value: dataTable
                                    };
                                }
                            }
                        }
                    }
                });
                dataPayload.push(objectRecord);

                let payload = {
                    successCallback,
                    errorCallback,
                    data: dataPayload,
                    shareId: this.$route.query.idShare
                };
                this.$store.dispatch('share/createDataShare', payload);
            } else {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'error',
                    message: this.$t('errorCheckMessage')
                });
            }
        },
        filterCondition(item) {
            let result = false;
            if (item) {
                if (item.required) {
                    result = true;
                } else if (item.type === TYPE_LINK) {
                    result = true;
                } else {
                    result = false;
                }
            }
            return result;
        },
        onValidate(field) {
            let check = true;
            let { dataRecord } = this;
            if (dataRecord) {
                let listDataRequired = this.listFields.filter(this.filterCondition);
                listDataRequired.map((elm) => {
                    this.errorInfo[elm.code] = '';
                    if (!field || field === elm.code) {
                        if (elm.type === TYPE_LINK) {
                            this.errorInfo[elm.code] = '';
                            if (dataRecord[elm.code]) {
                                if (elm.protocol === 'WEB' && !isUrl(dataRecord[elm.code])) {
                                    check = false;
                                    this.errorInfo[elm.code] = this.$t('msgCommon.msgLinkFormat', { field: elm.label });
                                }
                                if (elm.protocol === 'MAIL' && !validEmail(dataRecord[elm.code])) {
                                    check = false;
                                    this.errorInfo[elm.code] = this.$t('pageLogin.errorMailFormat');
                                }
                                if (elm.protocol === 'CALL') {
                                }
                            }
                        } else if (!dataRecord[elm.code] || (dataRecord[elm.code] && Array.isArray(dataRecord[elm.code]) && dataRecord[elm.code].length === 0)) {
                            this.errorInfo[elm.code] = this.$t('msgCommon.msgRequired', { field: elm.label });
                            check = false;
                        }
                    }
                });
            }
            if (!field) {
            }
            this.errorInfo = Object.assign({}, this.errorInfo);
            return check;
        }
    }
};
</script>
